import { useContext } from 'react';
import {
  DataContext,
  TFrontendConfigurationItem,
  TFilteredFrontendConfigurationItems,
  TExtendedSurfaceItem,
  TInputParams,
} from 'entries/common/widgets/context';
import { useSurfaceState } from 'pages/surface/store/hooks/surface';
import { useSurfaces } from 'pages/surface/hooks/use-surfaces';
import { ParametersEnum } from '../../types';
import { getFrontendConfigurationInputTypes } from '../helpers';

export const useFilteredInputParams = (): {
  filteredSurfaces: TExtendedSurfaceItem[];
  inputParameters: TInputParams;
  defaultInputParams: TInputParams;
  hasLengthWidth: boolean;
  frontendConfiguration: TFrontendConfigurationItem[] | null;
  frontendConfigurationInputs: TFilteredFrontendConfigurationItems;
} => {
  const data = useContext(DataContext);
  const surfaces = useSurfaces();
  const { surfaceFormState } = useSurfaceState();
  const frontendConfiguration = data?.surfaces.frontendConfiguration ?? null;
  const frontendConfigurationInputs = getFrontendConfigurationInputTypes(frontendConfiguration);
  const filteredSurfaces =
    surfaces.length > 1 ? surfaces.filter(surf => surfaceFormState[surf.name]) : surfaces;

  const inputParameters = Array.from([
    ...new Set(
      filteredSurfaces.reduce((acc: TInputParams, surface) => [...acc, ...surface.inputParameters], [])
    ),
  ]);

  const defaultInputParams = inputParameters.filter(
    param => ![ParametersEnum.doors, ParametersEnum.windows, ParametersEnum.area].includes(param)
  );

  const hasLengthWidth =
    inputParameters.includes(ParametersEnum.length) && inputParameters.includes(ParametersEnum.width);

  return {
    filteredSurfaces,
    inputParameters,
    defaultInputParams,
    hasLengthWidth,
    frontendConfiguration,
    frontendConfigurationInputs,
  };
};
